import { LegacyDevice } from 'console/device/device';
import { prettyFloat } from 'webui/utils/number';
import { OpenThermVariableName } from 'openTherm';
import { getLegacyOpenThermState } from './open-therm';
import { isRadioThermometer } from 'console/shared/content/device/thermometers/legacy/utils';
import { createSelector } from '@reduxjs/toolkit';
import { ThermometerState } from 'webui/utils/thermometers';
import { RfTypes } from 'z3k-parser/lib';
const getLegacyOpenThermSensorState = createSelector((_, config) => config, (device_state, config) => getLegacyOpenThermState(config.boiler_adapter_id ?? config.id, device_state), (config, open_therm_state) => {
    const { open_therm, limits: initial_limits } = config;
    const limits = initial_limits ? initial_limits : { high: null, low: null };
    const max_modulation = open_therm_state?.[OpenThermVariableName.mrml] ?? 100;
    const { ot_name } = open_therm || {};
    const ot_value = ot_name ? open_therm_state?.[ot_name] : null;
    const value = typeof ot_value === 'number' ? Number(prettyFloat(ot_value, 1)) : null;
    const high_limit = ot_name === OpenThermVariableName.rml ? max_modulation : limits?.high;
    return {
        value,
        no_connection: false,
        alarm: false,
        limits: {
            ...limits,
            high: high_limit ?? null,
        },
    };
});
const getLegacyRadioSensorState = createSelector((device_state, serial) => {
    if (device_state.rf_status && serial) {
        const { last_state } = LegacyDevice.active_thermometers(device_state?.thermometers || [])
            .filter(isRadioThermometer)
            .find((thermometer) => thermometer.serial === serial) || {};
        return { last_state, ...device_state.rf_status[serial] };
    }
    return null;
}, (device_state, serial, current_server_time) => current_server_time, (radio_sensor, current_server_time) => {
    if (radio_sensor == null) {
        return null;
    }
    const { last_state, water, motion_until, type, hum, bat, bat_v, dbm } = radio_sensor;
    const rf_indicators = { bat, bat_v, dbm, type };
    const no_connection = last_state === ThermometerState.not_connected;
    const sensor_state = { rf_indicators, no_connection };
    if (type === RfTypes.MLW) {
        return {
            ...sensor_state,
            value: null,
            alarm: water === true,
            no_connection: water === 'break' || no_connection,
        };
    }
    if (type === RfTypes.MLH) {
        return {
            ...sensor_state,
            value: hum ?? null,
            alarm: false,
        };
    }
    if (type === RfTypes.MLM) {
        return {
            ...sensor_state,
            value: null,
            alarm: motion_until > current_server_time,
        };
    }
    return {
        ...sensor_state,
        value: null,
        alarm: false,
    };
});
export const getLegacySensorState = (sensor_config, device_state, server_time) => {
    const radio_sensor_state = getLegacyRadioSensorState(device_state, sensor_config.serial, server_time);
    if (radio_sensor_state != null) {
        return radio_sensor_state;
    }
    return getLegacyOpenThermSensorState(device_state, sensor_config);
};
